<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                       
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="' الاشعارات'" :to="{name: 'notifications'}"> الاشعارات</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="row"> 
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                              <i class="flaticon-computer-4"></i> 
                                          الاشعارات

                                        </h4>
                                    </div>          
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <div class="table-responsive">
                                   <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    <table class="table table-bordered mb-4">
                                        <thead>
                                            <tr>
                                              <th>
                                                <a href="#" @click.prevent="resortData();">
                                                  <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                  <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                </a>
                                              </th>
                                                <th @click="resortData();">العنوان</th>
                                                <th @click="resortData();">الحالة</th>
                                                <th class="align-center">#</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in data.data" :key="index">
                                                <td>{{index+1}}</td>
                                                <td>{{item.title}}</td>
                                                <td>
                                                  <i class="flaticon-single-tick text-success" v-if="item.seen_at != null"></i>
                                                  <i class="flaticon-bell-3 text-warning" v-else></i>
                                                </td>
                                                <td class="text-center">
                                                <router-link
                                                  :title="'فتح'"
                                                  class="btn btn-info"
                                                  href="javascript:void(0);"
                                                  :to="{ name: 'notifications.showing', query: { id: item.id } }"
                                                >
                                                  فتح
                                                </router-link>

                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th>
                                                  <a href="#" @click.prevent="resortData();">
                                                     <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                     <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                  </a>
                                                </th>
                                                <th @click="resortData();">العنوان</th>
                                                <th @click="resortData();">الحالة</th>
                                                <th class="align-center">#</th>
                                            </tr>
                                        </tfoot>
                                        
                                    </table>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>
                         
                    </div>
                   
                </div>
            </div>


</template>
<script>

export default {
  data() {
    return {
      data: {
        data: {},
        searching:{
            id: '',
            title: '',
            perPage: 10,
           sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      }
    };
  },
  created(){
      this.getIndexData(1);
  },
  methods: {
     resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
      },
      getIndexData(page){
        this.$baseApi.get('/notifications?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data.notifications;
               this.data.data = response.data.data.notifications.data;
               this.updateNotifications();

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    },
    updateNotifications(){
      this.$baseApi.get('/new-notifications').then((response) => {
        if (response.data.code === 200 && response.data.data != null) {
            let resp = response.data.data;
            this.$store.dispatch('SET_NOTIFICATION_COUNT', resp.count);
            this.$store.dispatch('SET_NOTIFICATION_DATA', resp.data);
        }
      });
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
</style>
